/**
 * 该文件主要用于店铺装修每个版块type值
 */

// 司仪头部信息
export const DECORATION_SHOP_INFO = 'shopInfo'
// 司仪团队风采
export const DECORATION_SIYI_TEAM_STYLE = 'siyiTeamStyle'
// 司仪团队
export const DECORATION_GROUP_INFO = 'groupInfo'
// 司仪团队成员
export const DECORATION_GROUP_MEMBER = 'groupMember'
// 顶部背景 / 商家故事
export const DECORATION_BACKGROUND = 'background'
// 商家视频 / 顶部配置
export const DECORATION_MERCHANT_VIDEO = 'merchantVideo'
// 商家承诺
export const DECORATION_MERCHANT_PROMISE = 'merchantPromise'
// 商家公告
export const DECORATION_NOTICE = 'notice'
// 到店礼
export const DECORATION_GIFT = 'gift'
// 咨询礼
export const DECORATION_CONSULT_GIFT = 'consultGift'
// 优惠券
export const DECORATION_COUPON = 'coupon'
// 推荐橱窗
export const DECORATION_RECOMMEND_WINDOW = 'recommendWindow'
// 款式相册
export const DECORATION_STYLE_ALBUM = 'styleAlbum'
// 精选套餐 /
export const DECORATION_MEAL = 'meal'
// 婚戒精选套餐 /
export const DECORATION_RING_MEAL = 'ring_meal'
// 加盟店（商品）
export const DECORATION_JIA_MENG_GOODS = 'jiaMengGoods'
// 精选案例 / 商家作品
export const DECORATION_EXAMPLE = 'example'
// 商家活动
export const DECORATION_MERCHANT_ACTIVITY = 'merchantActivity'
// 商家动态
export const DECORATION_MERCHANT_UPDATES = 'merchantUpdates'
// 商家简介 / 商家故事
export const DECORATION_MERCHANT_INTRO = 'merchantIntro'
// 轻松聊 / 引导咨询-天眼系统
export const DECORATION_EASY_CHAT = 'easyChat'
// 问大家
export const DECORATION_ASK = 'askAnswer'
// 用户评价
export const DECORATION_EVALUATE = 'evaluate'
// 婚戒-热门系列
export const DECORATION_HOT_RING_SERIES = 'series'
// 三大团队封面
export const DECORATION_GROUP_COVER = 'groupCover'
// 新商家动态
export const DECORATION_MERCHANT_NEW_UPDATES = 'newMerchantUpdates'
// 商家荣誉（婚礼策划、婚纱礼服）
export const DECORATION_MERCHANT_HONOR = 'merchantHonor'
// 店铺广告（婚礼策划、婚纱礼服、司仪团队）
export const DECORATION_MERCHANT_BANNER = 'merchantBanner'
// 服务内容
export const SERVICE_CONFIG = 'serviceConfig'
// 个性化服务
export const SERVICE_UPGRADE = 'serviceUpgrade'
export const DECORATION_HOTEL_CASE = 'hotel_case'

// 样照
export const MEAL_TYPE_SAMPLE = 1
// 客照
export const MEAL_TYPE_GUESS = 2

// 开通旗舰版/尊享版才能使用的功能，同时也用于左侧金色背景蒙层显示
export const PRO_DECORATION_MODULE = [
  DECORATION_GIFT,
  DECORATION_CONSULT_GIFT,
  DECORATION_COUPON,
  DECORATION_RECOMMEND_WINDOW,
  DECORATION_EASY_CHAT,
  DECORATION_MERCHANT_ACTIVITY,
  DECORATION_MERCHANT_PROMISE,
  DECORATION_MERCHANT_BANNER
]

export const DECORATION_DEFAULT_TEXT = {
  [DECORATION_COUPON]: '请设置优惠券',
  [DECORATION_GIFT]: '请输入到店礼内容',
  [DECORATION_CONSULT_GIFT]: '请输入咨询礼内容',
  [DECORATION_NOTICE]: '请输入公告内容',
  [DECORATION_EASY_CHAT]: '请选择或输入接客问候'
}

export const DECORATION_JIA_MENG_MODULES = {
  [DECORATION_BACKGROUND]: '品牌展示',
  [DECORATION_MERCHANT_VIDEO]: '视频',
  [DECORATION_COUPON]: '优惠券',
  [DECORATION_NOTICE]: '公告',
  [DECORATION_GIFT]: '到店礼',
  [DECORATION_CONSULT_GIFT]: '咨询礼',
  [DECORATION_MERCHANT_ACTIVITY]: '商家活动',
  [DECORATION_RECOMMEND_WINDOW]: '橱窗',
  [DECORATION_JIA_MENG_GOODS]: '商品',
  [DECORATION_EXAMPLE]: '案例',
  [DECORATION_MERCHANT_UPDATES]: '动态',
  [DECORATION_ASK]: '问大家',
  [DECORATION_EVALUATE]: '用户评价',
  [DECORATION_EASY_CHAT]: '轻松聊'
}
